module.exports = __webpack_public_path__ + "static/media/osa-logo-light.05055081.svg";